module.exports = __webpack_public_path__ + "img/hg-demand.242e125e.svg";